/**
 * Component: Product Tabs
 * ------------------------------------------------------------------------------
 *
 * @namespace VehicleLookup
 */

import log from 'salvo-lite/log'
import VehicleStateUI from './VehicleState.vue'

class VehicleLookup {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            ...JSON.parse(elem.getAttribute('data-vehicle-state') || '{}')
        }
        this._variant = elem.getAttribute('data-vehicle-state-variant') || 'default'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const Partindex = window._esc_Partindex

        this.vehicleLookup = new Partindex.Vue({
            i18n: Partindex.i18n,
            el: this._elem,
            render: (e) => e(VehicleStateUI, {
                props: {
                    variant: this._variant || 'default',
                    productId: this._settings.productId
                }
            })
        })
    }
}

export default VehicleLookup



// WEBPACK FOOTER //
// ./src/resources/scripts/components/garage/VehicleState.js